import Stack from '@mui/material/Stack';
import React, { Fragment } from 'react';
import AppLogo from './AppLogo';
import MenuBar from './MenuBar';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { css } from '@emotion/css';
import pkg from '../../package.json';
import { useServices } from './ServiceProvider';
import { useMediaQuery } from '@mui/material';
const StyledAppLogo = () => (React.createElement(AppLogo, { className: css({
        marginLeft: '0.33em',
        marginRight: '0.5em'
    }) }));
const style = { userSelect: 'none' };
const AppHeader = () => {
    const { platformAPI } = useServices();
    const isLargeScreen = useMediaQuery('(min-width: 600px)');
    return (React.createElement(Stack, { sx: style, direction: "row", alignItems: "center", flexGrow: "1", justifyContent: "space-between" },
        React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "flex-start" },
            React.createElement(StyledAppLogo, null),
            React.createElement(MenuBar, { ipc: platformAPI })),
        isLargeScreen ? (React.createElement(Fragment, null,
            React.createElement(Stack, { direction: "row", justifyContent: "center", spacing: "0.5em" },
                React.createElement(Typography, null, pkg.productName),
                React.createElement(Typography, null, `v${pkg.version}`),
                React.createElement(Chip, { sx: { backgroundColor: "#6c3477" }, label: pkg.versionLabel, size: "small" })),
            React.createElement(Stack, { direction: "row", justifyContent: "flex-end" }))) : null));
};
export default AppHeader;
//# sourceMappingURL=AppHeader.js.map